import XRegExp from 'XRegExp'
import { calculateAge } from './utils/commonUtils'

const emptyValidatorBuilder = errMsg => value => {
  if (!value) {
    return errMsg
  }
  return undefined
}

const ageValidatorBuilder = ({ max, min }) => value => {
  if (max && value && calculateAge(new Date(value)) > max.value) {
    return max.errMsg
  }
  if (min && value && calculateAge(new Date(value)) < min.value) {
    return min.errMsg
  }
  return undefined
}

let NAME_REGEXP
try {
  NAME_REGEXP = XRegExp("(?:^[\\p{L}\\p{Thai}](?!.*([ '-]).*\\1)[\\p{L}\\p{Thai} '-]{0,125}[\\p{L}\\p{Thai}]$)|^[\\p{L}\\p{Thai}]$", 'u')
} catch (e) {
  // For IE
  NAME_REGEXP = XRegExp("(?:^[\\p{L}\\p{Thai}](?!.*([ '-]).*\\1)[\\p{L}\\p{Thai} '-]{0,125}[\\p{L}\\p{Thai}]$)|^[\\p{L}\\p{Thai}]$")
}
const nameValidatorBuilder = (i18n, emptyErrMsg, optional) => value => {
  if (!optional && !value) {
    return emptyErrMsg
  }
  if (value && value.length > 127) {
    return i18n('react-ui.validation.max', { max: 127 })
  }
  if (value && !NAME_REGEXP.test(value)) {
    return 'passport.error.validation.person.name'
  }
  return undefined
}

const PASSWORD_REGEXPS = {
  lowerCaseRegExp: /[a-z]+/,
  upperCaseRegExp: /[A-Z]+/,
  numericRegExp: /\d+/,
  specialRegExp: /(\W+|_+)/,
}
export const passwordValidator = (password, username, i18n) => {
  if (password && password.length < 8) {
    return 'passport.common.notice.pwdDescription'
  }

  if (password && password.length > 50) {
    return i18n('react-ui.validation.max', { max: 50 })
  }

  if (username && password === username) {
    return 'passport.common.notice.pwdDescription'
  }

  let matcheCounter = 0
  Object.keys(PASSWORD_REGEXPS).forEach(key => {
    matcheCounter += PASSWORD_REGEXPS[key].test(password) ? 1 : 0
  })

  if (matcheCounter < 3) {
    return 'passport.common.notice.pwdDescription'
  }

  return undefined
}

export const confirmPasswordValidator = (confirmPassword, password) => {
  if (confirmPassword !== password) {
    return 'passport.error.validate.pwdNotMatch'
  }

  return undefined
}

export {
  emptyValidatorBuilder,
  ageValidatorBuilder,
  nameValidatorBuilder,
}
